import { signIn } from "next-auth/react";
import {
  getUserBasicQuotaTrainsCount,
  getUserCreditQuotaTrainsCount,
} from "@/actions/db/train-voices";
import { getUserLicense } from "@/actions/db/get-user-license";
import { LicenseName } from "@/data/license.data";
import { getBlobDurationInSecs } from "@/utils/blob-utils";
import { customVoiceLicenseManager } from "@/services/license/license-managers/custom-voices-license-manager";
import { getCreditLimit } from "@/actions/db/credit-transaction";
import { $creditPriceList } from "@/data/credit-transaction.constants";
import licenseLimitedModal from "@/components/modal/license-limited-modals/license-limited-modal";

export const isVoicesLimited = async (
  user: any,
  creditBalance: number,
  showTrialModal: (userLicense: LicenseName) => void,
  showCreditLimitModal: () => void,
) => {
  if (!user?.id) {
    signIn();
    return true;
  }
  const userLicense = (await getUserLicense(user.id)) as LicenseName;

  if (
    await customVoiceLicenseManager.serviceUsingCountLimiter.isSlotsExpired(
      user.id,
      userLicense,
    )
  ) {
    const userCreditCustomVoices = await getUserCreditQuotaTrainsCount(user.id);
    const creditLimit = await getCreditLimit("CUSTOM_VOICE");

    if (userCreditCustomVoices >= creditLimit) {
      if (creditBalance >= $creditPriceList.customVoiceLimitPrice) {
        showCreditLimitModal();
      } else {
        showTrialModal(userLicense);
      }

      return true;
    }
  }

  return false;
};

export const isDatasetLengthLimited = async (
  datasetFiles: File[],
  license: LicenseName,
  userId: string,
): Promise<boolean> => {
  let datasetSecondsLength = 0;
  for (const datasetFile of datasetFiles) {
    const datasetDuration = await getBlobDurationInSecs(datasetFile).catch(
      (e) => {
        // TODO: catch works if file is corrupted.
        // Треба зробити перевірку на АПІ роуті, що якщо файл караптнутий, то повертати ерор і видавати модалку зі списком кораптнутих файлів.
        return 0;
      },
    );
    datasetSecondsLength += datasetDuration;
  }
  const result =
    await customVoiceLicenseManager.datasetDurationLimiter.isDatasetDurationLimited(
      userId,
      license,
      datasetSecondsLength,
    );

  return result.isLimited;
};
